/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { FC } from 'react'
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom'
import { PrivateRoutes } from './PrivateRoutes'
import { Logout, AuthPage } from 'Presentation/Views/Auth'
import { useAuthStore } from 'Store/Auth'
import { shallow } from 'zustand/shallow'
import { App } from '../App'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env

const AppRoutes: FC = () => {
  // const { accessToken, profile } = useAuthTokenStore()

  const accessToken = useAuthStore(state => state.accessToken, shallow)

  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='logout' element={<Logout />} />
          {accessToken ? (
            <React.Fragment>
              <Route path='auth' element={<Navigate to='/home' />} />
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/home' />} />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Route path='auth/*' element={<AuthPage />} />
              <Route
                path='*'
                element={
                  <Navigate
                    to='/auth'
                    state={{
                      prevPage: window.location.pathname + (window.location.search ?? ''),
                    }}
                  />
                }
              />
            </React.Fragment>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export { AppRoutes }
